<template>
  <section class="thanks-submitting">
  <!-- {{data.thanks_for_submitting_links}} -->
    <div class="green-nav">
      <div class="message">
        <img src="@/assets/img/thanks_icon.png" alt="Sad smile icon" />
        <p
          v-html="
            data.thanks_for_submitting_links_green_title
              ? data.thanks_for_submitting_links_green_title
              : 'Thanks for Submitting'
          "
        />
      </div>
      <div class="nav">
        <Button
          :url="page.custom_url || page.page?.post_url"
          :text="page.custom_title || page.page?.post_title"
          color="white"
          lineHover="bg-green"
          circleColor="circle-white"
          v-for="(page, index) in data.thanks_for_submitting_links"
          :key="index"
        />
      </div>
    </div>

    <div
      class="bottom"
      :class="data.thanks_for_submitting_image_below ? 'no-image' : ''"
    >
      <div class="text">
        <p class="title" v-html="data.thanks_for_submitting_bottom_title" />
        <div class="content" v-html="data.thanks_for_submitting_bottom_text" />
      </div>
    </div>

    <div class="image-tag" v-if="data.thanks_for_submitting_image_below">
      <div
        class="image"
        :style="{
          backgroundImage: `url(${data.thanks_for_submitting_image.url})`,
        }"
        v-if="data.thanks_for_submitting_image"
      ></div>

      <div
        class="tag"
        v-html="data.thanks_for_submitting_image_tag"
        v-if="data.thanks_for_submitting_image_tag"
      />
    </div>
  </section>
</template>

<script setup>
import Button from '@/components/utility/Button.vue'
// import Default from '@/assets/img/box_default.png'

defineProps(['data'])
// console.log(props.data.thanks_for_submitting_links_green_title)
</script>

<style lang="scss" scoped>
.thanks-submitting {
  @apply min-h-[100vh] relative py-[160px] lg:py-[240px] px-[10px];

  .green-nav {
    @apply relative bg-ore_green mx-auto max-w-[1390px] rounded-[27px] mb-20 py-5 flex md:flex-col lg:flex-row md:justify-between md:items-center gap-10 md:gap-0 md:pl-3 xl:py-9 xl:pr-12 xl:pl-8;

    .nav {
      @apply relative hidden md:flex md:justify-end w-auto items-start mt-4 md:mt-0 xl:flex-row xl:flex-wrap xl:justify-end xl:gap-y-[10px] xl:items-center;

      .button {
        @apply relative;

        &.white {
          @apply mx-6 py-5 my-0 lg:mx-5 xl:m-0 xl:mx-[50px];

          &:first-child {
            @apply xl:ml-0;
          }

          &:last-child {
            @apply xl:mr-0;
          }
        }

        + .button {
          &:before {
            @apply content-[''] absolute -left-[25px] top-0 bottom-0 w-[1px] bg-ore_orange hidden md:block xl:-left-[50px];
          }
        }
      }
    }

    .message {
      @apply relative flex justify-start items-center xl:flex-[1_0_auto] xl:w-auto xl:max-w-[480px];

      p {
        @apply text-white text-[24px] leading-none text-center md:text-left ml-0 md:ml-4 md:text-[30px];
      }

      img {
        @apply m-0 w-16 h-16 md:w-20 md:h-20;
      }
    }
  }

  .bottom {
    @apply relative main-container px-6 max-w-[1390px] mx-auto gap-4 md:flex md:items-center md:px-7 md:gap-8 xl:gap-24;

    :deep(.text) {
      @apply max-w-[1140px] flex-[1_0_auto] md:order-2 md:max-w-[60%] lg:w-1/2;

      p {
        &.title {
          @apply text-[20px] leading-[24px] mb-[40px] md:text-[24px] md:leading-none xl:text-[30px];
        }

        @apply text-[30px] leading-none mb-5 xl:text-[40px];
      }
    }

    .image {
      @apply flex gap-3 mt-20 md:order-1 md:mt-0;

      .nav {
        @apply w-1/2 flex-[1_0_auto] flex flex-col justify-center md:hidden;

        .button {
          &.green {
            @apply mb-0 mt-4 py-0;
          }
        }
      }

      .img-container {
        @apply flex flex-col justify-center rounded-[27px] overflow-hidden;
      }
    }

    &.no-image {
      @apply xl:my-36;

      :deep(.text) {
        @apply max-w-[960px] w-full;

        p {
          @apply md:text-[50px] lg:text-[70px];

          &.title {
            @apply md:text-[20px] lg:text-[30px];
          }
        }
      }

      .image {
        .nav {
          @apply w-full;
        }

        .img-container {
          @apply hidden;
        }
      }
    }
  }

  .image-tag {
    @apply relative rounded-[27px] mt-20 max-w-[1700px] mx-auto;

    .image {
      @apply relative bg-no-repeat bg-cover h-[540px] rounded-[27px] md:h-[768px];
    }

    :deep(.tag) {
      @apply relative bg-ore_green rounded-[27px] p-6 mt-[10px] md:absolute md:top-[22px] md:left-[18px] md:bottom-auto md:pr-14 md:p-5;

      p {
        @apply leading-[24px] text-[20px] text-white;
      }
    }
  }
}
</style>
